module.exports = __webpack_public_path__ + "b42b90cb7768a0d7d0e2507bb8bad056.svg";